module.exports = __webpack_public_path__ + "img/Aberdeenshire.d496daac.png";